import isEmpty from 'lodash/isEmpty';
import * as common from '../apiCommon';
import { CUSTOM_FIELD } from '../../constants/constant_doc_types';
import { toBoolean } from '../apiUtils';

export function fetchCustomFieldDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'custom_field/dropdown';
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams,
  };

  return common.getDropdownList(app, { query });
}

export const fetchCustomFieldById = (app, params) => {
  const { id } = params;
  const docType = CUSTOM_FIELD;

  return common.getDoc(app, { id, docType });
};

export const saveCustomField = (app, dataToSave) => {
  const { user = {}, data } = dataToSave;

  data.list_values = (data.list_values || []).filter(value => value);

  data.tabs = (data.tabs || []).filter(
    tab => tab.assigned_doc_type && tab.custom_tab_id,
  );

  const customFieldData = {
    active: data.active,
    description: data.description,
    doc_type: CUSTOM_FIELD,
    doc_types_applied_to: data.doc_types_applied_to,
    field_label: data.field_label,
    field_name: data.field_name,
    field_type: data.field_type,
    list_id: data.list_id,
    multiselect: data.multiselect,
    name: data.name,
    record_type: data.record_type,
    show_on_pos: toBoolean(data.show_on_pos),
    tabs: isEmpty(data.tabs)
      ? undefined
      : data.tabs.map(({ id, assigned_doc_type, custom_tab_id }) => ({
          id,
          assigned_doc_type,
          custom_tab_id,
        })),
  };

  return common.saveDoc(app, {
    source: data,
    doc: customFieldData,
    user,
  });
};

export const deleteCustomField = (app, data) => {
  return common.deleteDoc(app, {
    id: data.id,
    docType: CUSTOM_FIELD,
  });
};

export const fetchAssembledCustomFields = (app, docType) => {
  const service = app.service('custom_field/assemble');

  return service.get(docType);
}